import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const css = `
.dock-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: 40px;
    padding: 0 14px;
    border-radius: 12px;
    border: 0.5px solid rgba(0, 0, 0, 0.12);
    background: rgba(255, 255, 255, 0.88);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    color: #1a1a1a;
    font-size: 13px;
    font-weight: 500;
    letter-spacing: -0.01em;
    cursor: pointer;
    transition: background 0.18s, border-color 0.18s, transform 0.1s, box-shadow 0.18s, color 0.18s;
    white-space: nowrap;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    flex-shrink: 0;
}

.dock-btn:hover {
    background: #fff;
    border-color: rgba(0, 0, 0, 0.22);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.dock-btn:active {
    transform: scale(0.96);
}

.dock-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
    transform: none;
}

.dock-btn--active {
    background: #1a1a1a;
    color: #fff;
    border-color: #1a1a1a;
}

.dock-btn--active:hover {
    background: #000;
    border-color: #000;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
}

.dock-btn--icon-only {
    width: 40px;
    padding: 0;
    justify-content: center;
}

.dock-btn__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.dock-btn__icon svg {
    width: 20px;
    height: 20px;
    display: block;
}

.dock-btn__label {
    line-height: 1;
}

@media (max-width: 767px) {
    .dock-btn:not(.dock-btn--keep-label) .dock-btn__label {
        display: none;
    }
    .dock-btn:not(.dock-btn--keep-label):has(.dock-btn__icon) {
        width: 40px;
        padding: 0;
        justify-content: center;
    }
}
`;
export function DockButton({ icon, label, title, active, disabled, keepLabelOnMobile, onClick, }) {
    const isIconOnly = !label && !!icon;
    const className = [
        'dock-btn',
        active && 'dock-btn--active',
        isIconOnly && 'dock-btn--icon-only',
        keepLabelOnMobile && 'dock-btn--keep-label',
    ].filter(Boolean).join(' ');
    return (_jsxs(_Fragment, { children: [_jsx("style", { children: css }), _jsxs("button", { type: "button", className: className, onClick: onClick, disabled: disabled, title: title ?? label, "aria-label": title ?? label, children: [icon && _jsx("span", { className: "dock-btn__icon", children: icon }), label && _jsx("span", { className: "dock-btn__label", children: label })] })] }));
}
